import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import dragonCardCommon from '../../../assets/images/ranks/common.jpg';
import dragonCardCommonPerfect from '../../../assets/images/ranks/common_perfect.jpg';
import dragonCardRare from '../../../assets/images/ranks/rare.jpg';
import dragonCardRarePerfect from '../../../assets/images/ranks/rare_perfect.jpg';

import RanksCard from './RanksCard';

const BP1 = '@media (max-width: 900px)';
const BP2 = '@media (max-width: 750px)';

const sx = {
  description: {
    margin: 'auto',
    fontFamily: 'poppins',
    fontSize: '14px',
    color: '#D2D4C2',
    textAlign: 'center',
    lineHeight: '1.8',
  },
  descriptionLeftSide: {
    margin: 'auto',
    fontFamily: 'poppins',
    fontSize: '14px',
    color: '#D2D4C2',
    textAlign: 'center',
    lineHeight: '1.8',
    marginBottom: '30px',
    [BP2]: {
      marginBottom: '50px',
    },
  },
  title: {
    fontSize: '30px',
    fontFamily: 'boucherie-block',
    color: '#D2D4C2',
    textAlign: 'center',
    lineHeight: '40px',
    mb: '15px',
  },
  rank: {
    fontSize: '14px',
    fontFamily: 'boucherie-block',
    color: '#738078',
    textAlign: 'center',
  },
  container: {
    [BP1]: {
      gap: '0px 25px',
    },
  },
};

const Levels = () => {
  return (
    <>
      <Grid
        container
        justifyContent="center"
        sx={sx.container}
        style={{
          maxWidth: '842px',
          margin: 'auto',
          zIndex: 1,
        }}
      >
        <Grid item xs={12} md={6}>
          <Box>
            <Typography sx={sx.title}>COMMON</Typography>
            <RanksCard
              img={dragonCardCommon}
              scopeId={'comonCard'}
              scopeStyle={{
                width: '333px',
                height: '450',
                borderRadius: '20px',
              }}
            />
            <Typography
              sx={sx.descriptionLeftSide}
              style={{
                color: '#D2D4C2',
                marginTop: '30px',
                maxWidth: '280px',
              }}
            >
              Most of the cards are common. They are beautiful, and they are
              plentiful.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography sx={sx.title}>RARE</Typography>
            <RanksCard
              img={dragonCardRare}
              scopeId={'rareCard'}
              scopeStyle={{
                width: '333px',
                height: '450',
                borderRadius: '20px',
              }}
            />
            <Typography
              sx={sx.description}
              style={{
                color: '#D2D4C2',
                marginTop: '30px',
                maxWidth: '280px',
                marginBottom: '50px',
              }}
            >
              Rare cards have a unique color combination, a silver border and
              small variations in the design of the character. They are 10x
              rarer than a common version.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography sx={sx.title}>EPIC</Typography>
            <RanksCard
              img={dragonCardCommonPerfect}
              scopeId={'commonPerfectCard'}
              scopeStyle={{
                width: '333px',
                height: '450',
                borderRadius: '20px',
              }}
            />
            <Typography
              sx={sx.description}
              style={{
                color: '#D2D4C2',
                marginTop: '30px',
                maxWidth: '280px',
                marginBottom: '50px',
              }}
            >
              Each of the NFTs will come with a random background and is
              supporting layer combination. There are over 100,000 possible
              combinations. There is ONE combination for each of the 15
              characters that the artists selected as the “perfect match”.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography sx={sx.title}>LEGENDARY</Typography>
            <RanksCard
              img={dragonCardRarePerfect}
              scopeId={'rarePerfectCard'}
              scopeStyle={{
                width: '333px',
                height: '450',
                borderRadius: '20px',
              }}
            />
            <Typography
              sx={sx.description}
              style={{
                color: '#D2D4C2',
                marginTop: '30px',
                maxWidth: '280px',
              }}
            >
              If a card is both “Perfect” and “Rare”, then it is considered to be the most valuable.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Levels;
